import { Sparkles } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";
import { LANDING_PAGES, LANDING_SLUGS } from "@/data/landingPages";

/* Standalone service-pricing-guides section. Previously inlined inside
   Calculator.jsx — extracted so the `/guides` route can render it as a page. */
export default function GuidesSection({ lang = "ar", theme = "dark" }) {
  const dark = theme === "dark";
  const ar = lang === "ar";

  return (
    <section
      data-testid="landing-links-section"
      className={`${dark ? "bg-[#1f2a47]" : "bg-[#f3f8ff]"}`}
      dir={ar ? "rtl" : "ltr"}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex items-center gap-2 text-[#18c98f] text-xs uppercase tracking-[0.35em] font-bold">
          <Sparkles className="h-3.5 w-3.5" />
          {ar ? "أدلّة أسعار الخدمات" : "Service pricing guides"}
        </div>
        <h2
          className={`mt-3 font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl max-w-3xl ${
            ar ? "font-arabic" : "font-outfit"
          } ${dark ? "text-white" : "text-[#000000]"}`}
        >
          {ar
            ? "اكتشف أسعار السوق السعودي لكل خدمة على حدة"
            : "Discover Saudi market pricing per service"}
        </h2>
        <p
          className={`mt-2 max-w-2xl text-sm ${
            dark ? "text-white/70" : "text-[#2d2c35]/70"
          } ${ar ? "font-arabic" : "font-outfit"}`}
        >
          {ar
            ? "دليل أسعار مفصّل لكل خدمة مع تقدير فوري وجدول أسعار بالريال السعودي 2026."
            : "A detailed pricing guide per service with instant estimates in SAR for 2026."}
        </p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {LANDING_SLUGS.map((slug) => {
            const p = LANDING_PAGES[slug];
            return (
              <RouterLink
                key={slug}
                to={`/${slug}`}
                data-testid={`service-link-${slug}`}
                className={`group block rounded-2xl border p-4 transition ${
                  dark
                    ? "bg-[#182138] border-[#2e3a5c] hover:border-[#18c98f]"
                    : "bg-white border-[#e5e5ea] hover:border-[#18c98f]"
                }`}
              >
                <div className="text-[10px] font-bold text-[#18c98f] uppercase tracking-widest">
                  {p.tagline}
                </div>
                <div
                  className={`mt-2 text-sm font-bold font-arabic leading-snug group-hover:text-[#18c98f] transition ${
                    dark ? "text-white" : "text-[#000000]"
                  }`}
                >
                  {p.h1}
                </div>
              </RouterLink>
            );
          })}
        </div>
      </div>
    </section>
  );
}
